module.exports = __webpack_public_path__ + "img/splatter.6e249393.svg";